import { useState } from "react";
import { ChevronDown } from "lucide-react";

const QA = [
  ["What do I receive after I buy?", "Every product is a digital download. Right after payment you'll see download buttons for each format (for example PDF and EPUB), and we email you the same links. Nothing is shipped."],
  ["Can I re-download my purchases later?", "Yes. Open My Library, enter the email you used at checkout, and we'll send a one-time sign-in link. Every past purchase — in every format — is there whenever you need it."],
  ["Which formats do your ebooks come in?", "Most ebooks include PDF (great for printing and tablets) and EPUB (for Kindle, Apple Books, Kobo and other e-readers). The format list is shown on each product page before you buy."],
  ["How do the printable journals and stickers work?", "Journals are designed for US Letter and A4 and print beautifully at home or a copy shop; they also work in GoodNotes and Notability. Sticker sheets are high-resolution PNG/PDF files — print on full-sheet sticker paper and cut by hand or with a Cricut."],
  ["Can I send something as a gift?", "Absolutely. Tick “Send this as a gift” on any product or bundle, add your friend's email and a note, and they'll receive the download links the moment payment completes."],
  ["Is my payment secure?", "Payments are processed by Stripe; we never see or store your card details. Receipts are emailed automatically."],
  ["When do devotionals go out?", "A new devotional is published every Sunday morning and every past week is kept in the Devotionals archive."],
];

export function Faq() {
  const [open, setOpen] = useState(0);
  return (
    <section className="max-w-7xl mx-auto px-6 lg:px-10 pb-24" data-testid="faq-section" itemScope itemType="https://schema.org/FAQPage">
      <div className="grid lg:grid-cols-[1fr_2fr] gap-10">
        <div>
          <div className="overline text-[#d4af37]">Good to know</div>
          <h2 className="font-serif text-4xl text-[#0a192f] mt-3 leading-tight">Questions, answered.</h2>
          <p className="text-[#4a4a4a] mt-4">Everything about downloads, formats, printing, gifting and getting back into your library.</p>
        </div>
        <div className="divide-y divide-[#e5e5e5] border-t border-b border-[#e5e5e5]">
          {QA.map(([q, a], i) => (
            <div key={q} itemScope itemProp="mainEntity" itemType="https://schema.org/Question">
              <button data-testid={`faq-q-${i}`} onClick={() => setOpen(open === i ? -1 : i)} className="w-full flex items-center justify-between py-5 text-left">
                <span className="font-semibold text-[#0a192f]" itemProp="name">{q}</span>
                <ChevronDown className={`w-5 h-5 text-[#d4af37] transition-transform ${open === i ? "rotate-180" : ""}`} />
              </button>
              <div itemScope itemProp="acceptedAnswer" itemType="https://schema.org/Answer" className={open === i ? "pb-5" : "hidden"}>
                <p itemProp="text" className="text-[#1a1a1a] leading-relaxed">{a}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
